export default "<div class=\"action\">\n  {{actionToDisplay}}\n</div>\n\n";